import { ReactElement, memo } from 'react';
import { Tooltip } from '@mui/material';

import { useSubscription } from '~hooks/useSubscription';
import { isPlanEFlex } from '~utils/plans';
import Subscription from '~components/Subscription';

const AvailablesRoutesStateWrapper = (): ReactElement | null => {
  const subscription = useSubscription();

  if (isPlanEFlex(subscription)) return null;

  return (
    <Tooltip
      title="Estas son tus rutas disponibles para este ciclo."
      arrow
      placement="right"
    >
      <span>
        <Subscription.AvailableRoutesState.Info />
      </span>
    </Tooltip>
  );
};

export default memo(AvailablesRoutesStateWrapper);
